<template>
  <div
    v-if="corporateClient == 'hoval'"
    class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5"
  >
    <loading v-if="loadingState" />
    <Hoval />
  </div>
  <div
    v-else-if="corporateClient == 'emicon'"
    class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5"
  >
    <loading v-if="loadingState" />
    <Emicon />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import { USER_REQUEST, USER_SET_DEFAULT_SHIP_DATA } from "actions/user";
import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vue2-timepicker";
import Hoval from "./hoval.vue";
import Emicon from "./emicon.vue";
const moment = require("moment");

export default {
  name: "play",
  components: {
    Datepicker,
    VueTimepicker,
    Emicon,
    Hoval,
  },
  data() {
    return {
      loadingState: false,
      proccess: "START",
      userToken: "",
      partita_iva: "",
      existPIVA: false,
      existEmail: false,
      existCF: false,
      tempIva: "",
      tempCF: "",
      tempEmail: "",
      corporateClient: "",
      azienda: "",
      name: "",
      lastname: "",
      email: "",
      phone: "",
      cellulare: "",
      codice_fiscale: "",
      shipEqual: true,
      shipData: {},
      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      iban: "",
      ibanNome: "",
      ibanCognome: "",
      ship_regions: [],
      ship_regionsState: true,
      ship_provincies: [],
      ship_provinciesState: false,
      ship_cities: [],
      ship_citiesState: false,
      ship_zips: [],
      ship_zipsState: false,
      ship_provinceError: false,
      ship_cityError: false,
      ship_zipError: false,
      password: "",
      confirm_password: "",
      ship_name: "",
      ship_lastname: "",
      near: "",
      ship_phone: "",
      ship_cellulare: "",
      ship_address: "",
      ship_civic: "",
      ship_region: "",
      ship_province: "",
      ship_city: "",
      ship_zip: "",
      note: "",
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      invoiceRear: "",
      invoiceRearName: "",
      invoiceRearBucket: "",
      uploadRearPercentage: 0,
      id_eps: "",
      precompiled_iva: "",
      vw: window.innerWidth,
      logo: "",
      reg_forfettario: "",
    };
  },
  methods: {
    setProfile: function () {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
    },
  },
  watch: {
    getProfile() {
      this.setProfile();
    },
  },
  created() {},
  async mounted() {
    this.$log(this.$route);
    this.setProfile();
  },
  computed: {
    ...mapGetters(["getProfile", "isAuthenticated", "isProfileLoaded"]),
    ...mapState({
      profile: (state) => state.user.profile,
    }),
  },
};
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
  position: absolute;
  bottom: -37px;
  font-size: 17px;
  width: 100%;
  text-align: center;
  color: #0e3d8b !important;
  z-index: 12313;
  white-space: nowrap;
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.borderTop {
  border-top: 3px solid #003d13;
  padding-top: 15px;
}

.shopIcon {
  width: 75px;
}

.bigTitle {
  font-size: 47px;
  color: #003d13;

  @media screen and (max-width: $phone) {
    font-size: 27px;
  }
}

.hideFileUpload {
  position: absolute;
  width: 100%;
  height: 110%;
  background: #000000;
  opacity: 0.4;
  top: -18px;
  left: 0;
  filter: blur(24px);
  z-index: 10000;
}

h5 {
  @media screen and (max-width: $phone) {
    font-size: 14px;
  }
}
.corporateImg {
  max-height: 153px;
}
.backImageInvoice {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  > img {
    max-height: 477px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.zoomImage {
  position: absolute;
  left: 48%;
  top: 230px;
  cursor: pointer;
}

.vcenter {
  align-items: center;
  align-self: center;
  vertical-align: middle;
  display: inherit;
}

.front-image {
  position: relative;
  margin: 0 auto;
  display: block;
  height: 147px;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-item-align: center;
  align-self: center;
  width: 191px;
  margin-bottom: 17px;

  @media screen and (max-width: $tablet) {
    margin-top: 15px !important;
  }

  > .fileInputLabel {
    display: none;
  }

  > .invalid-feedback {
    display: block;
    position: absolute;
    bottom: 15px;
    font-weight: 800;
  }

  > input {
    position: absolute;
    filter: alpha(opacity=0);
    opacity: 0;
    left: 5px;
    width: 100%;
    height: 200px;
    z-index: 10;
    top: -20px;
  }

  > label {
    /*display: none;*/

    width: 100%;
    margin: 0 auto;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    position: relative;
    padding: 0!important !important;
    left: 0;

    > span {
      background-color: #dee6ff;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      border: 1px solid white;
      width: 192px;
      margin-top: 19px !important;
      display: block;
      height: 155px;
      margin: 0 auto;
      cursor: pointer;
      word-break: break-all;
      padding: 5px;
      color: white;
      border-radius: 7px;
      overflow-wrap: break-word;
      white-space: normal;
      line-height: 29px;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      align-self: center;
      vertical-align: middle;
      margin: auto;
      display: inline-grid;
      background-size: cover;
      background-position: center;

      &:before {
        content: "+";
        display: block;
        clear: both;
        text-align: center;
        height: 141px;
        width: 179px;
        border-radius: 7px;
        padding-top: 51px;
        font-size: 51px;
        font-weight: 600;
        color: #0091da;
        border: 3px solid #0091da;
      }

      @media screen and (max-width: $phone) {
        margin: 0 auto!important !important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important !important;
        float: none;
      }
    }

    &:after {
      content: "";
      display: block;

      clear: both;
      text-align: center;
      width: 237px;
      font-size: 10px;
      text-decoration: underline;
      color: black;

      /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

      @media screen and (max-width: $phone) {
        margin: 0 auto!important !important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important !important;
        float: none;
      }
    }

    @media screen and (max-width: $phone) {
      width: 100% !important;
      float: none !important;
      text-align: center !important;
      margin: 0 auto!important !important;
    }
    @media screen and (min-width: $phone) and (max-width: $tablet) {
      width: 100% !important;
      float: none !important;
      text-align: center !important;
      margin: 0 auto!important !important;
    }
  }
}

.center-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>


<style lang="css" scoped>
.sweetText {
  font-size: 26px;
}
.imageIcons {
  vertical-align: bottom !important;
  width: 50px;
}

.hSize {
  font-size: 33px !important;
}

.howPlayTextCont[data-v-54f59cc7] {
  max-width: 333px;
  text-align: left;
  margin: 0 auto;
  line-height: 27px;
  padding-left: 61px;
}

/* new PRICE */

.swal2-popup .swal2-title,
#swal2-content {
  color: #fffbde !important;
  display: block !important;
}

.replaceButton {
  max-width: 40px;
}

.inputHelper {
  margin-top: -32px;
  color: #0e3d8b;
  font-size: 16px;
  left: 0;
}

.priceVal,
.priceCent {
  width: calc(50% - 1.5vw - 7.5px);
  display: inline-table;
}

.pseudoEuro {
  position: absolute;
  top: 6px;
}
.pseudoCent {
  position: absolute;
  top: 6px;
  right: 0;
}

.group input:focus + .pseudoEuro {
  display: block;
}

.group .valid + .pseudoEuro {
  display: block;
}

.group input:focus + .pseudoCent {
  display: block;
}

.group .valid + .pseudoCent {
  display: block;
}

.euroInput {
  position: relative;
  width: 200%;
  z-index: 4;
}

.euroInput::before {
  content: "Euro";
}

.euroInput:focus,
.euroInput.valid {
  width: 100%;
}

.euroInput:focus::before,
.euroInput.valid::before {
  content: "Euro";
  color: white;
  position: absolute;
}

.table {
  display: table;
}

.newPriceLabel {
  z-index: 5;
  background: white;
  margin-left: -5px;
  padding-left: 5px;
  overflow: initial;
  min-width: calc(200% + 17px);
}

/*  ------------ */

.image-margin0 {
  margin: 0 !important;
}

.helper {
  color: #0e3d8b;
  font-size: 23px;
  font-family: Oswald-Medium;
}

.greyDesc2 {
  font-size: 1.1vw;
  color: #fffbde;
}

.redDesc {
  font-size: 1.1vw;
  text-decoration: underline;
  cursor: pointer;
}

.uploadDone {
  position: absolute;
  top: 10px;
  right: 0;
  color: #a1614f;
}

.helperUnderline {
}

.labelFileInput {
  top: -20px !important;
  font-size: 22px;
  color: #000000;
}

.fileInput {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 0;
  top: 17px;
  border-bottom: none;
  color: #000000;
}

.fileInputLabel {
  z-index: 3;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 20px;
  text-overflow: ellipsis;
  color: #fffbde;
}

.removeProduct {
  position: absolute;
  right: 21px;
  margin: 0px !important;
  top: 48px;
  color: #e7201d;
}

.typeDisabled {
  color: #676767;
  cursor: pointer;
}

.typeSelected {
  color: #fffbde !important;
  cursor: pointer;
}

@media (min-width: 20px) and (max-width: 767px) {
  .inputHelper {
    margin-top: -12px;
    color: #0e3d8b;
    font-size: 16px;
    left: 0;
  }

  .hSize {
    font-size: 19px !important;
  }
  .sweetText {
    font-size: 19px;
  }
  .removeProduct {
    position: absolute;
    right: 21px;
    margin: 0px !important;
    top: 26px;
    color: #e7201d;
  }

  .greyDesc2,
  .redDesc {
    font-size: 3.1vw;
  }

  .fluid {
    max-width: 107px;
  }

  .mobTQ {
    font-size: 23px;
  }

  .smMob {
    font-size: 1rem;
  }

  .howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7] {
    max-width: 350px;
    text-align: left;
    margin: 0 auto;
    line-height: 27px;
    padding-left: 43px;
    font-size: 17px;
  }

  .helper {
    color: #0e3d8b;
    font-size: 18px;
    font-family: Oswald-Medium;
  }
  .imageIcons {
    vertical-align: bottom !important;
    width: 39px;
  }
  .fileInput {
    top: 8px !important;
  }
}

@media (min-width: 768px) and (max-width: 1205px) {
  .disabledDatesMessage {
    top: -250%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/index.vue